// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"a13e1c14","287":"a13e1c14","442":"a13e1c14","479":"78574590","856":"d4e5609f","968":"47c6a84b"}[chunkId] + ".chunk.css";
};